export default {
    addZero(i) {
        if (i < 10) {
            i = "0" + i;
        }
        return i;
    },

    formatDateTime(d) {
        if (!d) return "-";
        //return this.formatHour(d) + " de " + this.formatDate(d);
        var dt = this.formatDate(d);
        var hh = this.formatHour(d);

        if(hh){
            return dt + " às " + hh;
        }
        else
        {
            return dt;
        }
    },

    formatDate(d) {
        return this.addZero(d.getDate()) + "/" + this.addZero(d.getMonth() + 1) + "/" + d.getFullYear();
    },

    formatPeriod(di, df) {
        return "De " + this.formatDateTime(di) + " até "+ this.formatDateTime(df);
    },
    formatISODateTime(d) {
        if (!d) return "-";
        var dt = this.formatISODate(d);
        var hh = this.formatHour(d);

        if(hh){
            return dt + "_" + hh;
        }
        else
        {
            return dt;
        }
    },

    formatISODate(d) {
        return d.getFullYear() + "-" + this.addZero(d.getMonth() + 1) + "-" + this.addZero(d.getDate());
    },

    formatHour(d) {
        var hh = d.getHours();
        var mm = d.getMinutes();

        if( hh === 0 && mm === 0){
            return undefined;
        }

        return this.addZero(hh) + "h" + (mm > 0 ? this.addZero(mm) : "");
    }
}